/**
 * 对接Emap数据格式的插件
 * 使用方法： new EmapPlugin({ url: '' })
 */
// eslint-disable-next-line node/no-deprecated-api
// import { resolve } from 'url'
import DEFAULT_SETTINGS from './defaultSettings';
import { getModel, getData } from '@/emap-utils';

const noop = function () {}; // const isAbsPath = (p) => {
//   return p.startsWith('http://') || p.startsWith('https://')
// }


const resolve = (from, to) => {
  const resolvedUrl = new URL(to, new URL(from, 'http://resolved'));

  if (resolvedUrl.hostname === 'resolved') {
    // `from` is a relative URL.
    const {
      pathname,
      search,
      hash
    } = resolvedUrl;
    return pathname + search + hash;
  }

  return resolvedUrl.toString();
};

const isPercent = str => {
  return typeof str === 'string' && str[str.length - 1] === '%';
};

export default class EmapPlugin {
  constructor(options) {
    this.settings = Object.assign({}, DEFAULT_SETTINGS, options);
  }

  install(ctx) {
    const self = this;
    const {
      settings
    } = self;
    ctx.plugin('props', (vm, props) => {
      return { ...props,
        selection: true,
        showPager: settings.pageable,
        pagerOptions: {
          pageSizes: settings.pageSizeOptions,
          layout: settings.pagerMode === 'advanced' ? 'prev, pager, next, jumper, ->, total' : 'prev, pager, next',
          ...props.pagerOptions
        },
        ...(settings.customOptions || {})
      };
    }); // ctx.plugin('init', async (vm) => {
    //   // 查询搜索区域配置
    //   const { pagePath, action: actionId } = settings
    //   const searchModal = await getModel({ pagePath, actionId, type: 'search' })
    //   const controls = searchModal && searchModal.controls
    //   if (controls) {
    //     const searchMeta = controls.filter(item => (item.quickSearch && !item['search.hidden']))
    //     vm.searchMeta = searchMeta
    //     vm.$emit('search-meta', searchMeta)
    //   }
    // })

    ctx.plugin('table-options', (vm, options) => {
      const {
        width
      } = this.settings;
      return { // height,
        ...options,
        style: width ? `width: ${width}` : null
      };
    }); // 自定义列定义查询

    ctx.plugin('fetch-meta', async (vm, columns, cb) => {
      const {
        pagePath,
        action: actionId,
        params,
        datamodel,
        alwaysHide = []
      } = settings;

      if (datamodel) {
        return datamodel;
      }

      try {
        const model = await getModel({
          pagePath,
          actionId,
          type: 'grid',
          params
        });

        if (model) {
          this.dataUrl = model.url;
          const metas = model.controls.filter(item => !item.hidden && !item['grid.hidden'] && !alwaysHide.includes(item.prop)).map(item => {
            const newItem = { ...item,
              label: item.caption,
              prop: item.name,
              fixed: !!item['grid.fixed'] || item.fixed // width: item['grid.width'] || item.width

            };

            if (item['grid.width']) {
              const width = item['grid.width'];

              if (isPercent(width)) {
                newItem.minWidth = width;
              } else {
                newItem.width = width || item.width;
              }
            }

            let jsonParam = item['form.JSONParam'];

            if (jsonParam) {
              try {
                jsonParam = JSON.parse(jsonParam);

                if (jsonParam.sortable) {
                  newItem.sortable = 'custom';
                }
              } catch (e) {
                console.warn('emap parse error, invalid JSONParam', jsonParam);
              }
            }

            return newItem;
          });
          cb(metas);
          vm.$emit('model-change', model);
        } else {
          cb(null);
        }
      } catch (e) {
        console.error(e);
        cb(null);
      }
    }); // 自定义数据查询

    ctx.plugin('fetch-data', async (vm, data, query, cb) => {
      const {
        dataUrl
      } = this;

      if (!dataUrl) {
        cb(null);
        return;
      }

      const {
        pagePath,
        action: actionId,
        beforeSend = noop
      } = settings; // const queryUrl = isAbsPath(dataUrl) ? dataUrl : resolve(pagePath, dataUrl)

      const queryUrl = resolve(pagePath, dataUrl);

      try {
        data = await getData(queryUrl, actionId, Object.assign({
          pageNumber: vm.currentPage,
          pageSize: vm.pageSize
        }, query), beforeSend.bind(vm), vm);
        cb(data);
      } catch (e) {
        console.error(e);
        cb(null);
      }
    });
    ctx.plugin('format-page', (vm, pager, data) => {
      const {
        totalSize = 0,
        pageNumber = 1,
        pageSize = 10
      } = data || {};
      return {
        total: totalSize,
        pageSize,
        pageNumber
      };
    });
    ctx.plugin('format-data', (vm, data = {}) => {
      const {
        rows
      } = data || {};
      return rows || [];
    });
    ctx.plugin('cell-render', (vm, value, row, col) => {
      const {
        cellRender
      } = this.settings;

      if (cellRender) {
        return cellRender(row, col);
      }

      const name = col.prop;
      const displayName = `${name}_DISPLAY`;

      if (displayName in row) {
        return row[displayName];
      }

      return value;
    });
  }

}